import { Stethoscope } from "lucide-react";

export default function AuthHero() {
  return (
    <div className="hidden lg:block relative border-r border-zinc-200">
      <img
        src="https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
        alt="Clinician"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-[#002FA7]/85" />
      <div className="relative h-full flex flex-col justify-between p-12 text-white">
        <div className="flex items-center gap-2.5">
          <Stethoscope className="h-6 w-6" />
          <span className="font-serif text-2xl tracking-tight">Medical CDSS</span>
        </div>
        <div>
          <h2 className="font-serif text-4xl tracking-tight leading-tight max-w-md">
            Evidence-based reasoning, from first symptom to final prescription.
          </h2>
          <p className="mt-4 text-white/80 text-sm max-w-md leading-relaxed">
            Referencing Harrison's 22e · NEJM · BMJ · JAMA
          </p>
        </div>
      </div>
    </div>
  );
}
